export class Formulario {
    mostrarFrmControl: boolean;
    mostrarFrmDetalle: boolean;

    constructor() {
        this.mostrarFrmDetalle = false;
        this.mostrarFrmControl = false;
    }
}
